<template>
  <div class="autocomplete-results-list">
    <ys-text type="body1" class="results-title">Search match</ys-text>
    <ul>
      <!-- eslint-disable-next-line vuejs-accessibility/click-events-have-key-events, vuejs-accessibility/no-static-element-interactions -->
      <li
        v-for="(result, index) in results"
        :key="`result-${index}`"
        data-test="autocomplete-result-item"
        @click="handleResultSelected(result, index)"
      >
        <autocomplete-result-item :result="result" />
      </li>
    </ul>
  </div>
</template>

<script lang="ts" setup>
import type { AutocompleteResult } from '@/lib/search/search-autocomplete'
import '@onxmaps/yellowstone-ui/ys-text'
import '@onxmaps/yellowstone-ui/ys-list-item'
import AutocompleteResultItem from '@/components/search/autocomplete-result-item.vue'

interface AutocompleteResultsProps {
  results: AutocompleteResult[]
}

const { results } = defineProps<AutocompleteResultsProps>()

const emit = defineEmits<{
  (e: 'result-selected', result: AutocompleteResult, index: number): void
}>()

const handleResultSelected = (result: AutocompleteResult, index: number) => {
  emit('result-selected', result, index)
}
</script>

<style scoped>
.results-title {
  padding: var(--ys-spacing-200) var(--ys-spacing-250) var(--ys-spacing-100);
}
</style>
